import { motion } from "framer-motion";
import { ArrowUp } from "lucide-react";

export default function Footer() {
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const year = new Date().getFullYear();

  return (
    <footer className="relative border-t border-stroke bg-obsidian" data-testid="site-footer">
      <div className="container-x py-14 md:py-16 grid grid-cols-12 gap-6 items-end">
        <div className="col-span-12 md:col-span-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="flex items-center gap-5"
          >
            <span className="inline-flex items-center justify-center">
              <img
                src="/dc-logo.png"
                alt="Digital Centaur"
                width="120"
                height="120"
                loading="lazy"
                className="w-12 h-12 md:w-14 md:h-14 object-contain"
              />
            </span>
            <div className="font-serif font-light text-4xl md:text-6xl leading-none text-ink">
              DIGITAL<span className="text-laser">.</span>CENTAUR
            </div>
          </motion.div>
          <div className="mt-4 font-mono text-[10px] tracking-[0.28em] uppercase text-steel">
            Himanshu Oberoi &middot; digitalcentaur.com
          </div>
        </div>

        <div className="col-span-12 md:col-span-3 md:justify-self-end">
          <div className="font-mono text-[10px] tracking-[0.28em] uppercase text-steel mb-2">Elsewhere</div>
          <a href="https://www.linkedin.com/in/himanshukumaroberoi" target="_blank" rel="noopener noreferrer"
            data-testid="footer-linkedin" className="block font-sans text-ink hover:text-laser transition-colors">
            LinkedIn ↗
          </a>
          <a href="mailto:connect@digitalcentaur.com" data-testid="footer-email"
            className="block font-sans text-ink hover:text-laser transition-colors">
            connect@digitalcentaur.com
          </a>
        </div>

        <div className="col-span-12 md:col-span-3 md:justify-self-end">
          <button onClick={toTop} data-testid="footer-to-top"
            className="btn-sweep inline-flex items-center gap-2 border border-stroke text-ink px-4 py-3 font-mono text-[11px] tracking-[0.24em] uppercase">
            <ArrowUp size={14} strokeWidth={1.5} />
            Back to Top
          </button>
        </div>
      </div>
      <div className="border-t border-stroke">
        <div className="container-x py-4 flex flex-wrap items-center justify-between gap-2 font-mono text-[10px] tracking-[0.24em] uppercase text-steel">
          <span>© {year} Digital Centaur &middot; Himanshu Oberoi.</span>
          <span>Dubai · UAE</span>
        </div>
      </div>
    </footer>
  );
}
